export const categories = [
  {
    id: 'beauty',
    name: '美妆护肤',
    slug: 'beauty',
    description: '日本原装进口护肤品、彩妆、面膜等精选好物',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20beauty%20skincare%20products%20elegantly%20arranged%20on%20a%20minimal%20wooden%20tray%20with%20cherry%20blossom%20petals%2C%20soft%20natural%20lighting%2C%20clean%20aesthetic%2C%20warm%20cream%20background%2C%20editorial%20product%20photography&width=800&height=600&seq=cat-beauty-01&orientation=landscape',
    productCount: 48,
  },
  {
    id: 'home',
    name: '家居日用',
    slug: 'home',
    description: '精致日式家居用品、厨房器具、收纳好物',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20home%20lifestyle%20products%20ceramic%20tableware%20and%20minimal%20home%20decor%20on%20light%20wooden%20surface%2C%20warm%20natural%20light%2C%20zen%20aesthetic%2C%20clean%20cream%20background%2C%20editorial%20photography&width=800&height=600&seq=cat-home-01&orientation=landscape',
    productCount: 36,
  },
  {
    id: 'snacks',
    name: '零食特产',
    slug: 'snacks',
    description: '日本地道零食、糖果、茶饮、特产美食',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20snacks%20and%20traditional%20sweets%20beautifully%20arranged%20on%20a%20ceramic%20plate%20with%20green%20tea%2C%20minimal%20composition%2C%20warm%20lighting%2C%20cream%20background%2C%20editorial%20food%20photography&width=800&height=600&seq=cat-snacks-01&orientation=landscape',
    productCount: 52,
  },
  {
    id: 'health',
    name: '健康保健',
    slug: 'health',
    description: '日本优质保健品、营养补充剂、健康食品',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20health%20supplements%20and%20wellness%20products%20displayed%20elegantly%20on%20minimal%20surface%2C%20natural%20elements%2C%20soft%20warm%20lighting%2C%20cream%20background%2C%20clean%20editorial%20style&width=800&height=600&seq=cat-health-01&orientation=landscape',
    productCount: 28,
  },
  {
    id: 'baby',
    name: '母婴用品',
    slug: 'baby',
    description: '日本母婴品牌、婴儿护理、孕产好物',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20baby%20and%20mother%20care%20products%20softly%20arranged%20on%20a%20gentle%20cream%20fabric%20background%2C%20minimal%20and%20pure%20aesthetic%2C%20warm%20natural%20lighting%2C%20editorial%20photography&width=800&height=600&seq=cat-baby-01&orientation=landscape',
    productCount: 22,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};